
import React from "react";
import { Timeline } from 'primereact/timeline';
import {MdPersonAdd, MdAddShoppingCart, MdOutlineShoppingCart } from 'react-icons/md'
import Colors from "../../utils/theme/colors";
import CommunityMenu from "./components/menus";
import CommunityActivityItem from "./components/act-item";

const activity_types = ['new_member', 'member_removed', 'member_leave', 'group_creation', 'new_order', 'order_fulfiled', 'new_contribution', 'group_details_change'];

function CommunityOrders(){
function Marker(){

//MdOutlineShoppingCart
return(
    <div className="flex-center" style={{width:"26px", height:'26px', borderRadius:"50%", backgroundColor:Colors.primary1}}>
        <MdAddShoppingCart size={14} color={Colors.primary} />
    </div>
)
}
return (
<div className='inner-content-bag' >
    <div className="row no-margin" style={{width:'100%'}}>
        <div className="col-md-3 no-padding-on-mobile" style={{padding:"0px 10px 0px 0px"}} >
            <CommunityMenu />
        </div>
        <div className="col-md-9 no-padding-on-mobile" style={{padding:"0px 0px 0px 10px"}}>
            <div style={{width:"100%", border:"0px solid "+Colors.bgShade1, borderRadius:'5px', textAlign:'left' }}>
                <div className='bold h5' style={{color:Colors.black, textDecoration:"underline", padding:"0px 10px 20px 10px"}}>
                    Community Orders
                </div>
                <div className="no-padding-on-mobile" style={{paddingLeft:"10px"}}>
                    <Timeline align="left" value={activity_types} 
                        content={(item)=>CommunityActivityItem(item, true)} marker={Marker} />
                </div>
            </div>
        </div>
    </div>
    <style>{`
    .p-timeline-event-opposite {display:none !important}
    .p-timeline-event-connector {background-color: ${Colors.primary1}}
    `}</style>
</div>
)
}
export default CommunityOrders;


